<template>
  <div class="pickup-tickets-container">
    <div class="pickup-tickets-wrapper">
      <header>{{ $t('pickup') }} {{ $tc('ticket', 1) }}</header>
      <button class="btn-modal-close" v-on:click="callClose()">&times;</button>
      <div class="pickup-tickets-center-content" v-if="enterTicketDetails">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <input v-model="booking_code" id="pickupCode" type="text" />
            <label>{{ $t('booking') }} {{ $t('code') }}</label>
            <VkeyboardFloat
            :ID="'pickupCode'"
            :onClickFun="() => {
              showVKeyboard = !showVKeyboard
            }"
          />
          <Vkeyboard
            :inputName="'pickupCode'"
            :showOrHide="showVKeyboard"
            :initialValue="booking_code"
            @onChangeEvent="() => {}"
            @onKeyEnter="showTicketInfomation"
            @changeKeyboardInput="booking_code = $event"
            @onClickClose="() => {
              showVKeyboard = false;
            }"
          />
          </div>
          <button class="btn-blue-lg" v-on:click="showTicketInfomation()">{{ $t('submit') }}</button>
        </div>
      </div>
      <threecopy-template ref="ThreeCopyTemp" :ticketDetails="TemplateList"></threecopy-template>

      <onecopy-template ref="OneCopyTemp" :ticketDetails="TemplateList"></onecopy-template>

      <default-template ref="DefaultTemp" :ticketDetails="TemplateList"></default-template>

      <div v-if="showTicketInfo">
        <div class="col-lg-10 col-xl-8 mx-auto border rounded-20 mb-lg-4 mb-xl-5">
          <div class="row">
            <div class="col-4 py-3 border-right">
              <div class="font-weight-bold">
                {{ticketDetails.screen_name}}
                <span>{{ $tc('seat', 1) }} :{{ticketDetails.seats.toString()}}</span>
              </div>
              <div
                class="font-weight-bold"
              >{{ $t('showtime') }}: {{ticketDetails.ss_start_show_time}}</div>
              <div class="font-weight-bold">{{ $t('date') }} : {{ticketDetails.show_date}}</div>
            </div>
            <div class="col-8 py-3">
              <h1 class="float-right">{{ticketDetails.seats.toString()}}</h1>
              <img
                src="@/assets/img/icons/movie-rolling.svg"
                width="75"
                style="position:absolute;bottom:15px;right:15px;"
              />
              <div class="font-weight-bold">{{ticketDetails.movie_title}}</div>
              <div
                class="font-weight-bold text-blue"
              >{{ticketDetails.lang_name}} | {{ticketDetails.mf_name}}</div>
              <div class="font-weight-bold">{{ticketDetails.screen_name}}</div>
              <div
                class="font-weight-bold"
              >{{ $t('showtime') }} : {{ticketDetails.ss_start_show_time}}</div>
              <div class="font-weight-bold">{{ $t('date') }} : {{ticketDetails.show_date}}</div>
            </div>
          </div>
        </div>
        <div class="pickup-tickets-options">
          <div class="row mx-auto">
            <!-- <div class="col-lg-4 col-xl-4 text-center d-flex justify-content-between flex-column">
              <div class="d-flex h-100 justify-content-center align-items-center">
                <img :src="ticketDetails.sb_qr_code" class="img-fluid" alt />
              </div>
              <p>Enter cinema using M-Ticket & QR Code Provided on your Booking Confirmation SMS</p>
            </div>-->
            <div class="col-lg-6 border-right-dashed h-100 d-none">
              <div class="pos-mobile-number">
                <div>
                  <div class="row">
                    <div class="col-12 mb-4">
                      <input type="number" v-model="input_number" placeholder="Mobile Number" />
                    </div>

                    <!-- <div> -->
                    <div v-if="isSearch" class="col-12 mb-4">
                      <input type="email" v-model="email_address" placeholder="Email Address" />
                    </div>
                    <div v-if="isSearch" class="col-6 mb-4">
                      <input type="text" v-model="first_name" placeholder="First Name" />
                    </div>
                    <div v-if="isSearch" class="col-6 mb-4">
                      <input type="text" v-model="last_name" placeholder="Last name" />
                    </div>
                    <!-- </div> -->

                    <div class="col-11 mx-auto">
                      <div class="row">
                        <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                        <button>{{mobile}}</button>-->

                        <div class="col-4 mb-2" v-for="(value, index) in phone_value " :key="index">
                          <button v-on:click="onClicknumber(index)">{{value.name}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <p>We will be sending you the movie ticket booking details on this mobile number.</p>
                <button
                  v-on:click="onClickDelete()"
                  class="btn-outline-blue-lg bg-transparent text-dark mr-1"
                >Delete</button>
                <button
                  v-if="!isSearch"
                  v-on:click="onSearch()"
                  class="btn-blue-lg bg-blue text-white ml-1"
                >Search</button>
                <button
                  v-else
                  v-on:click="onSendSMS()"
                  class="btn-blue-lg bg-blue text-white ml-1"
                >Send</button>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="pickup-icon-wrapper">
                <img src="@/assets/img/icons/box-office.svg" class="img-fluid" alt />
              </div>

              <div class="text-center">
                <p class="pb-4">Enter cinema with physical movie ticket</p>
                <button
                  v-if="isReprint"
                  @click="goToRoute()"
                  class="btn-outline-blue-lg bg-transparent text-dark mr-1"
                >Reprint</button>
                <button
                  v-if="!isReprint"
                  @click="goToRoute()"
                  class="btn-blue-lg bg-blue text-white ml-1"
                >Print</button>
                <button
                v-if="ShowPrintReceipt == 'Y'"
                  @click="PrintReceipt()"
                  class="btn-blue-lg bg-blue text-white ml-1"
                >Print Receipt</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <sales-receipt ref="SalesReceipt"></sales-receipt>
    </div>
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import OCTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/One_Copy_Template";
import ThreeCTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/3_Copies_Template";
import DefaultTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/Default_Template";
import SReceipt from "@/components/Pages/PosBookingContainer/sales_receipts";
import { EventBus } from "@/main";
import { BASEURL } from "@/config/index";
// import printJS from "./customPrint/index";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
export default {
  components: {
    "onecopy-template": OCTemplate,
    "threecopy-template": ThreeCTemplate,
    "default-template": DefaultTemplate,
    "sales-receipt": SReceipt,
    Vkeyboard,
    VkeyboardFloat
  },
  props: {
    onClickHandler: { type: Function }
  },
  data() {
    return {
      showVKeyboard: false,
      TemplateList: [],
      booking_code: "",
      item: {
        seatPrice: 0,
        seatType: "",
        seatName: ""
      },
      printIndex: 0,
      isReprint: false,
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "+" },
        { name: "0" },
        { name: "#" }
      ],
      input_number: "",
      email_address: "",
      first_name: "",
      last_name: "",
      cust_id: null,
      isSearch: false,
      isSetData: false,
      TemplateList: []
    };
  },
  watch: {
    "$store.getters.getIsOldCustomer": function(newVal, oldVal) {
      if (newVal) {
        this.email_address = this.$store.getters.getCustomerDetails.cust_email;
        this.first_name = this.$store.getters.getCustomerDetails.first_name;
        this.last_name = this.$store.getters.getCustomerDetails.last_name;
        this.cust_id = this.$store.getters.getCustomerDetails.cust_id;
      }
    }
  },
  computed: {
     ShowPrintReceipt() {
      return this.$store.getters.showPrintReceiptBtn;
    },
    getIsOldCustomer() {
      return this.$store.getters.getIsOldCustomer;
    },
    ticketDetails() {
      return this.$store.getters.TICKET_DETAILS;
    },
    enterTicketDetails() {
      return this.$store.getters.enterTicketDetails;
    },
    showTicketInfo() {
      console.log(', this.$store.getters.showTicketInfo; PRINT', this.$store.getters.showTicketInfo);
      return this.$store.getters.showTicketInfo;
    },
      bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
  },
  beforeMount() {
    const { cinema_id } = this.secureStore.get("USINFO");

    this.getCinemaTicketTemplate(cinema_id);
  },
  methods: {
    getCinemaTicketTemplate: function(cinema_id) {
      let body = {
        cine_id: cinema_id
      };
      MasterService.TicketTemplateByCinemaID(body).then(response => {
        const { data } = response;
        console.log("data ::::::::::", data);

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;
          }
        }
      });
    },
    onClicknumber: function(index) {
      this.input_number += this.phone_value[index].name;
    },
    onClickDelete: function() {
      this.input_number = "";
    },
    onSendSMS() {
      if (this.input_number.length > 0) {
        this.$store.dispatch("updateCustomerBookings", {
          first_name: this.first_name,
          last_name: this.last_name,
          mobile_number: this.input_number,
          cust_email: this.email_address,
          cust_id: this.cust_id
        });
        this.first_name = "";
        this.last_name = "";
        this.input_number = "";
        this.email_address = "";
        this.isSearch = false;
      }
    },
    onSearch: function() {
      if (this.input_number.length > 0) {
        // this.$toasted.show("Ticket Booking Details Sent Successfuly. ");
        this.$store.dispatch("setUserDeatils", {
          sb_mobile_number: this.input_number
        });
        this.isSearch = true;
        this.$store.dispatch("onSetAndSendLog", {
          action: `SMS option selected for ticket at number : ${this.input_number}`,
          page_name: "POS booking",
          api_name: window.location.hash
        });
      } else {
        this.$toasted.show("Please enter Mobile Number.");
      }
      // SendSmS Service
    },
    goToRoute: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: this.isReprint
          ? `Selected Reprint option .`
          : `Selected Print option .`,
        page_name: "POS booking",
        api_name: window.location.hash
      });
      this.isReprint = true;
      const { cinema_id } = this.secureStore.get("USINFO");

      //For electron
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        // Electron-specific code
        try {
          if (this.$socket) {
            this.$socket.emit("on_print_ticket", {
              showBookingId: this.bookingDetails.sb_id,
              cinema_id,
              baseurl: BASEURL,
              isReprint: this.isReprint
            });
          }
        } catch (err) {
          console.log("ERROR in PRINT", err);
        }
      } else {
        const p = new Printd();
        console.log(
          "this.TemplateList[0].template_id :",
          this.TemplateList[0].template_id
        );

        if (this.TemplateList[0].template_id == 1) {
          EventBus.$emit("printThreeCopyTemp");
        } else if (this.TemplateList[0].template_id == 2) {
          EventBus.$emit("printOneCopyTemp");
        } else if (this.TemplateList[0].template_id == 3) {
          EventBus.$emit("printDefaultTemp");
        } else {
          EventBus.$emit("printDefaultTemp");
        }
      }
    },
    PrintReceipt: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Selected PrintReciept button for ticket print.`,
        page_name: "POS Final Ticket",
        api_name: window.location.hash
      });
      // const p = new Printd();
      // p.print(this.$refs.SalesReceipt, []);
      EventBus.$emit("printSalesReceipt");
    },
    callClose: function() {
      this.$store.dispatch("resetPickUpTicketDetails");
      this.onClickHandler("PosPickUpTicket");
    },
    showTicketInfomation: function() {
      if (this.booking_code == "") {
        // this.$toasted.show("Please Enter Valid Booking Id");
      } else {
        this.$store.dispatch("onSetAndSendLog", {
          action: ` Selected PickUp Ticket Option for booking code :${this.booking_code} . `,
          page_name: "Pos PickUp Ticket",
          api_name: window.location.hash
        });
        this.$store.dispatch("FETCH_BOOKING_DETAILS", this.booking_code);
        // this.enterTicketDetails = false;
        // this.showTicketInfo = true;
      }
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posPickUpTickets.vue